module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sign-up"
    }
  }, [_c('div', {
    staticClass: "page animsition text-center sign-up-wrapper",
    class: {
      'vertical-align': !_vm.validation.registrationSuccess
    },
    attrs: {
      "data-animsition-in": "fade-in",
      "data-animsition-out": "fade-out"
    }
  }, [_c('div', {
    staticClass: "page-content",
    class: {
      'vertical-align-middle': !_vm.validation.registrationSuccess
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "28px",
      "padding-bottom": "22px"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.trackado.com"
    }
  }, [_c('img', {
    staticClass: "brand-img",
    attrs: {
      "src": '/Assets/landing/logo-landing.png'
    }
  })])]), _vm._v(" "), (!_vm.validation.registrationSuccess) ? _c('div', [_c('div', {
    staticClass: "login-page-title"
  }, [_vm._v("\n                    Create your Trackado account\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "login-page-description"
  }, [_vm._v("\n                    30 days free trial. No credit cards. Cancel anytime.\n                ")]), _vm._v(" "), (_vm.validation.registeredUser) ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "error-message"
  }, [_vm._v("Email already registered")]), _vm._v("\n                    Great, you already signed-up with this email address!"), _c('br'), _vm._v("\n                    Please go to "), _c('a', {
    attrs: {
      "href": "../login"
    }
  }, [_vm._v("Sign In")]), _vm._v(" to access your account."), _c('br'), _vm._v("\n                    Forgot you password? Please click "), _c('a', {
    attrs: {
      "href": "/Account/ForgotPassword"
    }
  }, [_vm._v("here")]), _vm._v(" to reset your password."), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.validation.invalidEmail) ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "error-message"
  }, [_vm._v("We couldn't verify this email address at the moment.")]), _vm._v("\n                    Please use a valid, non-temporary email address."), _c('br'), _vm._v("\n                    Try again with a different email or try again later."), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "register-form"
  }, [_c('form', {
    attrs: {
      "id": "submit-login"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onUserRegistration.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group form-material inp-error-marker"
  }, [_c('v-input-text', {
    attrs: {
      "type": _vm.text,
      "label": 'WORK EMAIL',
      "placeholder": 'Work Email',
      "value": _vm.email,
      "required": true,
      "showError": _vm.validation.forEmail,
      "errorMessage": _vm.emailErrorMsg
    },
    on: {
      "input": function (val) { return (_vm.email = val); },
      "focus": function($event) {
        _vm.validation.forEmail = false
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-input-error"
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "friendly-captcha"
    }
  }), _vm._v(" "), (!_vm.signUpSubmitted) ? _c('button', {
    staticClass: "btn btn-success btn-block login-btn",
    attrs: {
      "type": "submit",
      "id": "register-submit-btn",
      "disabled": !_vm.isSubmitBtnDisabled
    }
  }, [_vm._v("GET STARTED")]) : _c('button', {
    staticClass: "btn btn-success btn-block login-btn",
    attrs: {
      "type": "button",
      "hidden": ""
    }
  }, [_c('img', {
    staticClass: "loader-icon-gif",
    attrs: {
      "src": '/Assets/loader.gif'
    }
  })])])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.validation.registrationSuccess) ? _c('div', {
    staticClass: "registration-success-content"
  }, [_c('div', [_c('div', {
    staticClass: "check-inbox"
  }, [_c('img', {
    attrs: {
      "src": '/Assets/landing/icon-registration-success.png'
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "success-page-text password-changed"
  }, [_vm._v("\n                        We have sent an email to "), _c('span', {
    staticClass: "email-receiver bold"
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v("."), _c('br')]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])]) : _vm._e(), _vm._v(" "), _vm._m(4)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-in-link"
  }, [_vm._v("\n                    Do you already have an account? Please go to "), _c('a', {
    attrs: {
      "href": "../login"
    }
  }, [_vm._v("Sign In")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-page-title password-changed"
  }, [_vm._v("\n                        Please check your email"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-page-text password-changed"
  }, [_vm._v("\n                        Click the link in the email to confirm your address and to set up your account."), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-page-description password-changed"
  }, [_vm._v("\n                        Didn't get the email? "), _c('a', {
    attrs: {
      "href": "../Account/Registration"
    }
  }, [_vm._v("Start over")]), _vm._v(" to send it again.\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "friendly-captcha-login-div-registration"
  }, [_c('p', [_vm._v("This site is protected by "), _c('a', {
    attrs: {
      "href": "https://friendlycaptcha.com/",
      "target": "_blank"
    }
  }, [_vm._v("Friendly Captcha")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-56fefc16!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./modules/sign-up-page/SignUpPage.vue
// module id = 2832
// module chunks = 37